import { ROUTES } from '@/shared/constants/routes';
import { Loader } from '@/view/shared/Loader';
import {
  setRedirectAfterLogin,
  useIsPlatformAdmin,
  useLogtoStarting,
} from '@/viewmodel/features/user';
import { useLogto } from '@logto/react';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export function ProtectedRouteAdmin({ children }: { readonly children: ReactNode }) {
  const { isAuthenticated } = useLogto();
  const isLogtoStarting = useLogtoStarting();
  const { isPlatformAdmin, isLoading } = useIsPlatformAdmin();
  const location = useLocation();

  if (isLogtoStarting) return <Loader />;
  if (!isAuthenticated) {
    setRedirectAfterLogin(location.pathname + location.search);
    return <Navigate to={ROUTES.HOME} replace />;
  }
  if (isLoading) return <Loader />;
  if (!isPlatformAdmin) return <Navigate to={ROUTES.WORKSPACES} replace />;

  return <>{children}</>;
}
